import React, { useContext } from "react";

import { CardContent, CircularProgress, Typography } from "@mui/material";

import { ActionType } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/action_pb";

import { PermissionsContext } from "../../../context/permissions-context";
import Settings from "./lone-worker/settings";
import { SettingsContextProvider } from "./lone-worker/settings-context";

interface Props {
  roleId: string;
  regionCode: string;
}

const OrgLoneWorkerSettingsTab = (props: Props) => {
  const { hasPermissions, permissions } = useContext(PermissionsContext);

  if (permissions.isPermissionsLoading) {
    return (
      <CardContent>
        <CircularProgress />
      </CardContent>
    );
  }

  const canGetLoneWorkerSettings = hasPermissions([
    ActionType.GET_LONEWORKER_ORG_SETTINGS,
  ]);

  return (
    <>
      {canGetLoneWorkerSettings ? (
        <SettingsContextProvider>
          <Settings {...props} />
        </SettingsContextProvider>
      ) : (
        <CardContent>
          <Typography>
            You do not have permission to access Lone Worker settings
          </Typography>
        </CardContent>
      )}
    </>
  );
};

export default OrgLoneWorkerSettingsTab;
